import { Input, InputHandle, InputProps } from "@introist/react-foundation/v2";
import { TagSelectContext, TagSelector } from "modules/system/tags/TagSelector";
import { Tag } from "modules/system/tags/useTags";
import { useCallback, useRef } from "react";

type TagAwareInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  size?: "small" | "medium" | "large";
  disabled?: boolean;
  error?: boolean;
  tagSelectContext?: TagSelectContext;
} & InputProps;

export const TagAwareInput = ({
  value,
  onChange,
  placeholder,
  size = "small",
  disabled,
  error,
  tagSelectContext,
  ...rest
}: TagAwareInputProps) => {
  const inputRef = useRef<InputHandle>(null);

  const addTag = useCallback(
    (tag: Tag) => {
      if (!inputRef.current) return;
      inputRef.current.insertTextToCursorPosition(`{{${tag.tag}}}`);
    },
    [inputRef]
  );

  return (
    <Input
      ref={inputRef}
      size={size}
      placeholder={placeholder}
      value={value}
      endAdornment={<TagSelector title="" size={size} onSelect={addTag} ctx={tagSelectContext} />}
      onChange={onChange}
      disabled={disabled}
      error={error}
      {...rest}
    />
  );
};
